<template>
    <section class="input-group">
        <div v-if="setDeals && setDeals.length > 0" class="container-select-deal-card scroll-color">
            <div class="container-title-subtitle">
                <div><i class="fal fa-users-class" /></div>
                <div class="title">Seu cliente possui múltiplos negócios</div>
                <div class="subtitle">Selecione qual negócio você deseja preencher a proposta</div>
            </div>

            <div v-for="(deal, index) in setDeals" :key="index" class="container-card-content">
                <div class="container-card-content-header">
                    <div class="name-identifier">
                        <div class="icon-user-residence">
                            <em class="fal fa-user-circle" />

                            <div class="user-residence">
                                <span class="name-user">{{ setDealsCustomer }}</span>
                                <span class="residence">{{ deal.product }}</span>
                            </div>
                        </div>

                        <div class="cadastral-analysis">
                            <div class="analysis">{{ deal.stage }}</div>

                            <div class="cadastral">
                                {{ deal.status ? deal.status : 'Sem Status' }}
                            </div>
                        </div>
                    </div>

                    <div class="container-data-personal">
                        <div class="proposal-inditifier">
                            <div v-if="deal.stage == 'Proposta'" class="proposal">
                                {{ deal.stage }}
                            </div>
                            <ui-tag-indicator color="#1cca85" :text="deal.id" />
                        </div>

                        <div class="email">
                            Email:
                            <span class="email-content">
                                {{ existsData(deal.email) }}
                            </span>

                            <span class="tooltip-email">{{ existsData(deal.email) }}</span>
                        </div>
                    </div>
                </div>

                <div class="cellphone">
                    <span class="cell">
                        Celular:
						<span class="numbercell">{{ existsData(formatPhoneNew(deal.country_code_mobile, deal.mobile)) }}</span>
                    </span>

                    <span class="phone">
                        Telefone:
                        <span class="numberphone">{{ existsData(formatPhoneNew(deal.country_code_phone, deal.phone)) }}</span>
                    </span>
                </div>

                <div v-show="loading" class="loading-page">
                    <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                </div>
                <div class="details-button">
                    <span class="view-details" @click="openDetails(deal.id)">
                        Visualizar detalhes
                    </span>
                    <div class="actions-area">
                        <ui-button
                            design="success xs"
                            @click="openCustomerPageDeal(deal.id, deal.stageId, deal.statusId)"
                        >
                            Preencher proposta
                        </ui-button>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="form-user">
            <div class="customers-type">
                <ui-radio
                    v-for="type in options.types"
                    :key="type.id"
                    :checked="form.type === type.value"
                    :label="type.label"
                    :value="type.value"
                    design="primary"
                    name="type"
                    inline
                    @input="typeHandler"
                />
            </div>

            <select-deal
                v-model="form.name"
                :is-required-field="isRequired.name"
                :disabled-input="disabled.name"
                :is-proposal="isProposal"
                :submit-menu-proposal="submitMenuProposal"
                @handle-full-modal="handleFullModal"
            />

            <section class="input-group">
                <ui-input
                    v-model="form.email"
                    :required="isRequired.email"
                    :observation="obsMessage.email"
                    :disabled="disabled.email"
                    :loading="loader.email"
                    :error="observations.email != ''"
                    :clear-error-on-focus="false"
                    container-design="mgb-10"
                    size="sm"
                    label="E-mail:"
                    type="email"
                    complete-event="email-deal-guide"
                >
                    <section v-if="loader.email && !observations.email">
                        <small>{{ checkingDuplicityText }}</small>
                    </section>

                    <section
                        v-if="customersDuplicityHasBeenFound.email.found && !observations.email"
                    >
                        <small class="duplicity-found" @click="showDuplicityFound">{{
                            form.email && form.email != ''
                                ? customersDuplicityHasBeenFoundTextComputed(
                                    'Email',
                                    customersDuplicityHasBeenFound.email.type
                                )
                                : customersDuplicityHasBeenFoundTextComputed('', 'empty')
                        }}</small>
                    </section>
                </ui-input>
            </section>
            <div class="input-inline">
                <section class="input-group">
                    <ui-input
                        v-model="form.mobile"
						maskIntl="mobile"
                        :required="isRequired.mobile"
                        :observation="obsMessage.mobile"
                        :disabled="disabled.mobile"
                        :loading="loader.mobile"
                        :error="observations.mobile != ''"
                        :clear-error-on-focus="false"
                        container-design="mgb-10"
                        size="sm"
                        label="Celular:"
                        type="text"
                        complete-event="mobile-deal-guide"
                    >
						
                        <section v-if="loader.mobile && !observations.mobile">
                            <small>{{ checkingDuplicityText }}</small>
                        </section>

                        <section
                            v-if="
                                customersDuplicityHasBeenFound.mobile.found && !observations.mobile
                            "
                            class="duplicity-found"
                        >
                            <small @click="showDuplicityFound">
                                {{
                                    form.mobile && form.mobile != ''
                                        ? customersDuplicityHasBeenFoundTextComputed(
                                            'Celular',
                                            customersDuplicityHasBeenFound.mobile.type
                                        )
                                        : customersDuplicityHasBeenFoundTextComputed('', 'empty')
                                }}
                            </small>
                        </section>
                    </ui-input>
                </section>

                <section class="input-group">
                    <ui-input
                        v-model="form.phone"
						maskIntl="phone"
                        :required="isRequired.phone"
                        :observation="obsMessage.phone"
                        :disabled="disabled.phone"
                        :loading="loader.phone"
                        :error="observations.phone != ''"
                        :clear-error-on-focus="false"
                        container-design="mgb-10"
                        size="sm"
                        label="Telefone:"
                        type="text"
                        complete-event="phone-deal-guide"
                    >
                        <section v-if="loader.phone && !observations.phone">
                            <small>{{ checkingDuplicityText }}</small>
                        </section>

                        <section
                            v-if="customersDuplicityHasBeenFound.phone.found && !observations.phone"
                            class="duplicity-found"
                        >
                            <small @click="showDuplicityFound">{{
                                form.phone && form.phone != ''
                                    ? customersDuplicityHasBeenFoundTextComputed(
                                        'Telefone',
                                        customersDuplicityHasBeenFound.phone.phone
                                    )
                                    : customersDuplicityHasBeenFoundTextComputed('', 'empty')
                            }}</small>
                        </section>
                    </ui-input>
                </section>
            </div>

            <section class="input-group">
                <ui-input
                    v-if="form.type === 'Pessoa Fisica'"
                    v-model="form.cpf"
                    :mask="['###.###.###-##']"
                    :required="isRequired.cpf"
                    :observation="obsMessage.cpf"
                    :disabled="disabled.cpf"
                    :loading="loader.cpf"
                    :error="observations.cpf != ''"
                    :clear-error-on-focus="false"
                    container-design="mgb-10"
                    size="sm"
                    label="CPF:"
                    type="text"
                    complete-event="cpf-deal-guide"
                >
                    <section v-if="loader.cpf && !observations.cpf">
                        <small>{{ checkingDuplicityText }}</small>
                    </section>

                    <section v-if="customersDuplicityHasBeenFound.cpf.found && !observations.cpf" class="duplicity-found">
                        <small @click="showDuplicityFound">{{
                            form.cpf && form.cpf != ''
                                ? customersDuplicityHasBeenFoundTextComputed(
                                    'CPF',
                                    customersDuplicityHasBeenFound.cpf.type
                                )
                                : customersDuplicityHasBeenFoundTextComputed('', 'empty')
                        }}</small>
                    </section>
                </ui-input>

                <ui-input
                    v-else
                    v-model="form.cnpj"
                    :mask="['##.###.###/####-##']"
                    :required="isRequired.cnpj"
                    :observation="obsMessage.cnpj"
                    :disabled="disabled.cnpj"
                    :loading="loader.cnpj"
                    :error="observations.cnpj != ''"
                    :clear-error-on-focus="false"
                    container-design="mgb-10"
                    size="sm"
                    label="CNPJ:"
                    type="text"
                    complete-event="cnpj-deal-guide"
                >
                    <section v-if="loader.cnpj && !observations.cnpj">
                        <small>{{ checkingDuplicityText }}</small>
                    </section>

                    <section v-if="customersDuplicityHasBeenFound.cnpj.found && !observations.cnpj" class="duplicity-found" >
                        <small @click="showDuplicityFound">{{
                            form.cnpj && form.cnpj != ''
                                ? customersDuplicityHasBeenFoundTextComputed(
                                    'CNPJ',
                                    customersDuplicityHasBeenFound.cnpj.type
                                )
                                : customersDuplicityHasBeenFoundTextComputed('CNPJ', '')
                        }}</small>
                    </section>
                </ui-input>
            </section>

            <ui-select-v2
                v-model="form.origin_id"
                :data="options.origin"
                :required="isRequired.origin"
                :observation="obsMessage.origin"
                :open-event="originEvent"
                :loading="loader.origin"
                :disabled="disabled.origin"
                design="br-default"
                size="sm"
                label="Origens:"
                item-label="label"
                return-value="id"
            />
        </div>
    </section>
</template>

<script>
import { uiSelectV2, uiInput, uiRadio } from '@/components/ui/form'
import { uiButton } from '@/components/ui/buttons'
import { utilMixin, formMixin, alertMixin, loaderMixin, helpersMixin, maskIntl } from '@/mixins'
import { uiTagIndicator } from '@/components/ui/tags'
import { uiLoadIndicator } from '@/components/ui'

import selectDeal from '../../select-deal'

import { storage } from '@/services/storage'
import { origins, customer, openSearch } from '@/services/axios'

import { getConfig } from '@/views/configurations/util/methods'

import axios from 'axios'

import { mapGetters } from 'vuex'

const defaultTypes = () => [
	{ id: 1, label: 'Pessoa Física', value: 'Pessoa Fisica' },
	{ id: 2, label: 'Pessoa Jurídica', value: 'Pessoa Juridica' },
]

const defaultForm = () => ({
	type: 'Pessoa Fisica',
	name: '',
	email: '',
	mobile: '55',
	phone: '55',
	cpf: '',
	cnpj: '',
	origin_id: null,
})

const defaultOptions = () => ({
	origin: [],
	types: [],
})

const defaultLoader = () => ({
	name: false,
	email: false,
	mobile: false,
	phone: false,
	cpf: false,
	cnpj: false,
	origin: false,
})

const defaultRequired = () => ({
	name: false,
	email: false,
	mobile: false,
	phone: false,
	cpf: false,
	cnpj: false,
	origin: false,
})

const defaultObservation = () => ({
	name: '',
	email: '',
	mobile: '',
	phone: '',
	cpf: '',
	cnpj: '',
	origin: '',
})

const defaultDisabled = () => ({
	name: false,
	email: false,
	mobile: false,
	phone: false,
	cpf: false,
	cnpj: false,
	origin: false,
})

const defaultCustomersDuplicityHasBeenFound = () => ({
	name: {
		type: 'partial',
		found: false,
	},
	email: {
		type: 'partial',
		found: false,
	},
	mobile: {
		type: 'partial',
		found: false,
	},
	phone: {
		type: 'partial',
		found: false,
	},
	cpf: {
		type: 'partial',
		found: false,
	},
	cnpj: {
		type: 'partial',
		found: false,
	},
})

export default {
	name: 'ui-nugget-customer-form',

	components: {
		uiSelectV2,
		uiInput,
		uiRadio,
		selectDeal,
		uiButton,
		uiTagIndicator,
		uiLoadIndicator,
	},

	mixins: [utilMixin, formMixin, alertMixin, loaderMixin, helpersMixin, maskIntl],

	props: {
		value: {
			type: Object,
			required: true,
		},
		fetchList: {
			type: Object,
			default() {
				return {}
			}
		},
		/**
		 * Define quais são os campos requeridos/obrigatórios para o cadastro
		 */
		requiredFields: {
			type: Object,
			default: () => ({}),
		},
		observations: {
			type: Object,
			default: () => ({}),
		},
		nuggetId: {
			type: [String, Number],
			default: '',
		},
		duplicityConfig: {
			type: Object,
			default: () => ({}),
		},
		isProposal: {
			type: Boolean,
		},
		submitMenuProposal: {
			type: Function,
			required: true,
		}
	},

	data() {
		return {
			form: { ...defaultForm() },
			options: { ...defaultOptions() },
			loader: { ...defaultLoader() },
			setDeals: null,
			setDealsCustomer: null,
			nuggetName: 'nugget-customer-form',
			originEvent: 'get--customer-origins',
			originAlreadyRequested: false,
			betaFeatures: null,
			abortToken: null,
			checkingDuplicityText: 'Verificando duplicidade...',
			customersDuplicityHasBeenFoundText: 'Um cliente foi encontrado',
			disabled: { ...defaultDisabled() },
			customersDuplicityHasBeenFound: { ...defaultCustomersDuplicityHasBeenFound() },
			customersDuplicityFound: [],
			customerToUpdate: false,
			loading: false,
			fromReserveModal: false,
			createProposal: false
		}
	},

	computed: {
		...mapGetters('auth', { user: 'getUser' }),

		isRequired() {
			return {
				...defaultRequired(),
				...this.requiredFields,
			}
		},

		obsMessage() {
			return {
				...defaultObservation(),
				...this.observations,
			}
		},

		nuggetTotalName() {
			return this.nuggetName + (this.nuggetId ? '-' + this.nuggetId : '')
		},

		strongDuplicity() {
			return this.duplicityConfig.compare == 'or'
		},
		duplicityFields() {
			if(this.fromReserveModal && this.duplicityConfig?.reserve?.field?.length) {
				return this.duplicityConfig.reserve.field
			} else if(this.createProposal) {
				if(this.duplicityConfig?.proposal?.field?.length) {
					return this.duplicityConfig.proposal.field
				}else {
					return this.duplicityConfig.field
				}
			}
			return this.duplicityConfig.customer.field
		},
		isDynamicUser() {
			return this.user && this.user.isDynamicGroup ? true : false
		},

		openSearchAllowed() {
			return (
				(this.betaFeatures &&
					this.betaFeatures.opensearch &&
					this.betaFeatures.opensearch[this.user.user_group]) == 1 ||
				(this.isDynamicUser && this.betaFeatures.opensearch['dynamic'] == 1)
			)
		},

		duplicityActivated() {
			return this.duplicityConfig.status == 'active'
		},
	},

	watch: {
		options: {
			deep: true,
			handler(newValue) {
				this.$emit('update:fetchList', newValue)
			},
		},

		form: {
			deep: true,
			handler(newValue) {
				let disabled = []

				const atLeastOneIsTrue = (disabled) => {
					let leastOne = false

					Object.keys(this.disabled).forEach((item) => {
						leastOne = this.disabled[item]
						disabled.push(this.disabled[item])
					})

					return leastOne
				}

				const enableFields = () => {
					Object.keys(this.disabled).forEach((item) => {
						this.disabled[item] = false
					})
				}

				if (newValue && atLeastOneIsTrue(disabled)) {
					if (disabled.filter(Boolean).length > 1) {
						enableFields()
					}
				}

				this.$emit('input', newValue)
			},
		},

		disabled: {
			deep: true,
			handler(newValue) {
				if (
					newValue['name'] ||
					newValue['email'] ||
					newValue['mobile'] ||
					newValue['phone'] ||
					newValue['cpf'] ||
					newValue['cnpj']
				) {
					this.$root.$emit('create-deal-cant-submit', true)
					return
				}

				this.$root.$emit('create-deal-cant-submit', false)
			},
		},
	},

	async mounted() {
		this.$root.$on('select-deal-override-customer', (deal) => {
			if (deal && deal.length > 0 && deal[0]._source){
				this.setDeals = []
				this.setDealsCustomer = deal[0]._source.customer_name
				deal.map((value) => {
					let item = {}
					item.id = value._source.id_deal
					item.name = value._source.customer_name
					item.product = value._source.product_name
					item.stage = value._source.stage
					item.stageId = value._source.funnel_stage_id
					item.updated = value._source.updated_at
					item.status = value._source.status
					item.statusId = value._source.funnel_stage_status_id
					item.cpf = value._source.cpf
					item.phone = value._source.phone
					item.mobile = value._source.mobile
					item.email = value._source.email
					item.cnpj = value._source.cnpj
					item.country_code_mobile = value._source.customer_country_code_mobile
					item.country_code_phone = value._source.customer_country_code_phone
					this.setDeals.push(item)
				})
			}
		})
		/**
		 * Nome sempre vai esta ativo para fazer comparação de duplicidade
		 */
		this.$root.$on('create-deal--verify-deal-name', (value) => {
			if (value) this.ableToCheckDuplicity(value, 'name')
		})
		this.$root.$on('email-deal-guide', (value) => {
			if (value) this.ableToCheckDuplicity(value, 'email')
		})
		this.$root.$on('mobile-deal-guide', (value) => {
			if (value) this.ableToCheckDuplicity(value, 'mobile')
		})
		this.$root.$on('phone-deal-guide', (value) => {
			if (value) this.ableToCheckDuplicity(value, 'phone')
		})
		this.$root.$on('cpf-deal-guide', (value) => {
			if (value) this.ableToCheckDuplicity(value, 'cpf')
		})
		this.$root.$on('cnpj-deal-guide', (value) => {
			if (value) this.ableToCheckDuplicity(value, 'cnpj')
		})
		this.options.types = [...defaultTypes()]

		this.betaFeatures = JSON.parse(storage.get('beta_features'))

		this.$root.$on('select-v2-open-event-' + this.originEvent, async () => {
			if (!this.originAlreadyRequested) {
				this.$mx_setLoader('origin', true)
				this.options.origin = await this.getOrigins()
				this.originAlreadyRequested = true
				this.$mx_setLoader('origin', false)
			}
		})

		this.$root.$on(this.nuggetTotalName, async (payload) => {
			if (!this.form.type) this.typeHandler('Pessoa Fisica')

			if (payload) {
				const { type, name, email, mobile, phone, cpf, cnpj, origin } = this.payload
				if (type) this.form.type = type
				if (name) this.form.name = name
				if (email) this.form.email = email
				if (mobile) this.form.mobile = mobile
				if (phone) this.form.phone = phone
				if (cpf) this.form.cpf = cpf
				if (cnpj) this.form.cnpj = cnpj
				if (origin) this.form.origin_id = origin
			}
		})

		this.$root.$on('clean--' + this.nuggetTotalName, () => {
			this.form = { ...defaultForm() }
			this.originAlreadyRequested = false

			this.abortToken = null

			this.disabled = { ...defaultDisabled() }
			this.customersDuplicityHasBeenFound = { ...defaultCustomersDuplicityHasBeenFound() }
			this.customersDuplicityFound = []
			this.customerToUpdate = false

			this.$root.$emit('create-deal-cant-submit', false)
		})

		this.$root.$on('create-deal-override-customer', (customer) => {
			this.customerToUpdate = true

			// Reset this first
			this.customersDuplicityHasBeenFound = { ...defaultCustomersDuplicityHasBeenFound() }

			// Run override
			Object.keys(this.form).forEach((item) => {
				if (item == 'origin_id') return

				// Override local value with customer value
				if (item != 'cnpj' && item != 'type') this.form[item] = customer[item]

				this.$nextTick(() => {
					this.disabled[item] = true
				})
			})

			/**
			* Junta o customer_country_code e o phone/mobile para sobrescrever  
			* o input Telefone/Celular quando o usuário encontrado é selecionado
			*/
			if(this.form.phone){
				this.form.phone = customer.customer_country_code_phone + customer.phone
			}
			if(this.form.mobile){
				this.form.mobile = customer.customer_country_code_mobile + customer.mobile
			}

			this.$root.$emit('create-deal-load-override-customer', customer)
		})

		this.$root.$on('select-deal-override-customer', (customer) => {
			if (customer && customer.length > 0 && customer[0]._source) {
				this.customerToUpdate = true
			 // Reset this first
				this.customersDuplicityHasBeenFound = { ...defaultCustomersDuplicityHasBeenFound() }
			// Run override
				Object.keys(this.form).forEach((item) => {

					if (item == 'origin_id') return
					// Override local value with customer value
					if (item != 'cnpj' && item != 'type') this.form[item] = customer[0]._source[item]
					this.$nextTick(() => {
						this.disabled[item] = true
					})
				})
			}
		})

		this.$root.$on('create-deal-clear-duplicity-found', () => {
			this.clearDuplicityFound()
		})

		this.$root.$on('modal-open-global--request-reserve', () => {
			this.$root.$on('modal-open-create-deal-modal', (params, fromReserveModal = false) => {
				this.fromReserveModal = fromReserveModal
			})
		})

		this.$root.$on('modal-open-create-deal-modal', (params = null) => {
				this.createProposal= params && params === 'createProposal'
		})

		this.$root.$on('clean-form', this.cleanSetDeal)
	},

	updated() {
		this.handleChangeFooter()
	},

	beforeDestroy() {
		this.$root.$off('select-v2-open-event-' + this.originEvent)
		this.$root.$off(this.nuggetTotalName)
		this.$root.$off('clean--' + this.nuggetTotalName)
		this.$root.$off('create-deal-override-customer')
		this.$root.$off('create-deal-clear-duplicity-found')
		this.$root.$off('create-deal--verify-deal-name')
		this.$root.$off('email-deal-guide')
		this.$root.$off('mobile-deal-guide')
		this.$root.$off('phone-deal-guide')
		this.$root.$off('cpf-deal-guide')
		this.$root.$off('cnpj-deal-guide')
		this.$root.$off('clean-form', this.cleanSetDeal)
	},

	methods: {
		async getOrigins() {
			try {
				return (await origins.getOrigins('user')).data
			} catch (error) {
				return []
			}
		},
		handleChangeFooter() {
			if (this.setDeals && this.setDeals.length > 0) {
				this.$emit('handle-change-footer', true)
			} else {
				this.$emit('handle-change-footer', false)
			}
		},
		existsData(value) {
			return value && value != '' && !Array.isArray(value) ? value : 'Não cadastrado.'
		},
		// formatedPhone(value) {
		// 	if (!value || value == '' || Array.isArray(value)) {
		// 		return null
		// 	}
		// 	return value
		// 		.replace(/\D/g, '')
		// 		.replace(/(\d{2})(\d)/, '($1) $2')
		// 		.replace(/(\d{4})(\d)/, '$1-$2')
		// 		.replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
		// 		.replace(/(-\d{4})\d+?$/, '$1')
		// },
		openDetails(id) {
			const customerURL = this.$mx_oldPanelLink('vendas/negocios/' + id)
			window.open(customerURL)
		},
		typeHandler(type) {
			this.form.type = type
			this.form.cnpj = ''
			this.form.cpf = ''
		},
		showDuplicityFound() {
			this.$root.$emit(
				'modal-open-create-deal-override-customer',
				this.customersDuplicityFound
			)
		},
		clearDuplicityFound() {
			// Reset this
			this.form = { ...defaultForm() }

			// Reset this
			this.customersDuplicityHasBeenFound = { ...defaultCustomersDuplicityHasBeenFound() }

			// Reset this
			this.disabled = { ...defaultDisabled() }

			// Emit to up
			this.$root.$emit('create-deal-clear-override-customer')

			// Reset this
			this.customerToUpdate = false
		},

		checkDuplicityDegree(field) {
			const disableFields = (bool) => {
				Object.keys(this.disabled).forEach((item) => {
					if (item != field) this.disabled[item] = bool
				})
			}

			if (this.strongDuplicity) {
				const someDuplicityHasBeenFound = this.customersDuplicityHasBeenFound[field].type === 'full' &&
					this.customersDuplicityHasBeenFound[field].found
				disableFields(someDuplicityHasBeenFound)
				return
			}

			let everythingWasDuplicated = this.duplicityFields.map(duplicityField => {
				return this.customersDuplicityHasBeenFound[duplicityField].type === 'full' &&
					this.customersDuplicityHasBeenFound[duplicityField].found
			})

			disableFields(everythingWasDuplicated.every(Boolean))
		},

		manipulateCustomersDuplicityHasBeenFound() {
			const reset = (field) => {
				this.customersDuplicityHasBeenFound[field] = {
					type: 'partial',
					found: false,
				}
			}

			const set = (field, type, found) => {
				this.customersDuplicityHasBeenFound[field] = {
					type: type,
					found: found,
				}
			}

			return { reset, set }
		},

		checkDuplicityLocally(toFind, field) {
			if (this.abortToken) this.abortToken.cancel(field)
			if (!toFind || toFind == '') {
				// Reset this
				this.manipulateCustomersDuplicityHasBeenFound().reset(field)

				// Stop duplicity check loading warning
				this.loader[field] = false

				return
			}

			// Reset this
			this.manipulateCustomersDuplicityHasBeenFound().reset(field)

			// Start duplicity check loading warning
			this.loader[field] = true

			let found = false

			this.customersDuplicityFound.forEach((alreadyItemInData) => {
				if (!found && alreadyItemInData[field] && toFind)
					found = this.$mx_isEqual(alreadyItemInData[field], toFind)
			})

			if (found) this.manipulateCustomersDuplicityHasBeenFound().set(field, 'full', true)

			this.checkDuplicityDegree(field)

			// Stop duplicity check loading warning
			this.loader[field] = false

			return found
		},

		async checkDuplicity(toFind, field) {
			if (this.abortToken) this.abortToken.cancel(field)

			if (!toFind || toFind == '') {
				// Reset this

				this.manipulateCustomersDuplicityHasBeenFound().reset(field)

				// Stop duplicity check loading warning
				this.loader[field] = false

				return
			}

			// Axios 0.22 introduced the new https://developer.mozilla.org/en-US/docs/Web/API/AbortController
			// and made CancelToken deprecated. The facilita system is still using axios 0.19 so i will have to use CancelToken...
			this.abortToken = axios.CancelToken.source()

			try {
				// Reset this

				this.manipulateCustomersDuplicityHasBeenFound().reset(field)

				// Start duplicity check loading warning
				this.loader[field] = true

				let response = undefined
				if (this.openSearchAllowed)
					response = await openSearch.search(
						toFind,
						this.getInstance(),
						this.abortToken.token
					)
				else response = await customer.filter(toFind, this.abortToken.token)

				const data = this.openSearchAllowed ? response.data.hits.hits : response.data.data

				if (data.length <= 0) {
					// Stop duplicity check loading warning
					this.loader[field] = false

					// Reset this
					this.disabled = { ...defaultDisabled() }

					return
				}

				let hasExactlySameData = false
				this.customersDuplicityFound = []

				data.forEach((dataCustomer) => {
					let propData = this.openSearchAllowed ? dataCustomer._source : dataCustomer

					if (this.openSearchAllowed) {
						propData['id_customer'] = propData.customer_id
						propData['name'] = propData.customer_name
						propData['email'] = propData.customer_email
						propData['mobile'] = propData.customer_mobile
						propData['phone'] = propData.customer_phone
						propData['cpf'] = propData.customer_cpf

						// in the opensearch route, there is no data:
						// - CNPJ
						// - Type

						propData['owners'] = {}
						propData['owners']['team_id'] = null
						propData['owners']['broker_id'] = null
						propData['owners']['manager_id'] = null

						delete propData['id']
					}

					const alreadyInData = this.customersDuplicityFound.find(
						(alreadyItemInData) =>
							propData['id_customer'] == alreadyItemInData['id_customer']
					)

					// Check if this same object does not exist
					if (!alreadyInData) {
						propData['checked'] = false
						this.customersDuplicityFound.push(propData)
					}

					if (!hasExactlySameData && propData[field] && toFind)
						hasExactlySameData = this.$mx_isEqual(propData[field], toFind)
				})

				this.manipulateCustomersDuplicityHasBeenFound().set(
					field,
					hasExactlySameData ? 'full' : 'partial',
					true
				)
				this.checkDuplicityDegree(field)

				// Stop duplicity check loading warning
				this.loader[field] = false

			} catch (error) {
				// Remove duplicity check loading warning from other fields when request is canceled
				if (error.message) {
					Object.keys(this.loader).forEach((item) => {
						if (item != error.message) this.loader[item] = false
					})
				}
			}
		},
		async ableToCheckDuplicity(event, field) {
			if (!this.duplicityActivated || this.customerToUpdate) return

			this.$nextTick(async () => {
				// See if duplicity is enabled in this field
				if (!this.duplicityFields.includes(field)) return

				// Only do the duplicate check if everything is ok with the field
				if (this.obsMessage[field] != '') return

				let toFind = undefined
				if (['cpf', 'cnpj'].includes(field))
					toFind = this.$mx_numbersOnly(event)
				else toFind = event

				// Check duplicity locally first
				if (this.checkDuplicityLocally(toFind, field)) return

				await this.checkDuplicity(toFind, field)
			})
		},
		customersDuplicityHasBeenFoundTextComputed(field, type) {
			if (type == 'partial') return this.customersDuplicityHasBeenFoundText
			if (type == 'full') return field + ' já cadastrado.'
			if (type == 'empty') return field

			return this.customersDuplicityHasBeenFoundText
		},
		openCustomerPageDeal(id, stage, status) {
			this.$root.$emit('customer-open-chosen', id, stage, status)
			this.handleFullModal()
		},
		handleFullModal() {
			this.$emit('handle-full-modal', true)
		},
		getConfig,
		cleanSetDeal() {
			this.setDeals = []
		}
	}
}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>
